// extracted by mini-css-extract-plugin
export var preview = "preview-module--preview--3U4NQ";
export var link = "preview-module--link--2YfxN";
export var play = "preview-module--play--1BcbR";
export var row = "preview-module--row--Ezsyb";
export var col = "preview-module--col--3glqy";
export var first = "preview-module--first--RM463";
export var second = "preview-module--second--30WNM";
export var left = "preview-module--left--2f5pn";
export var shape = "preview-module--shape--2KPIr";